import React from 'react';
import Routers from './Route';
import Providers from './Providers';

const App = () => (
    <div className='App'>
        <Providers>
            <Routers />
        </Providers>
    </div>
);

export default App;